import { FormFieldV2 } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

interface Props {
  formMode: FormMode;
}

export const ExchangeRateTab = ({ formMode }: Props) => {
  return (
    <div className='flex flex-col gap-3 p-4'>
      <FormFieldV2
        label='Sửa tỷ giá ghi sổ'
        className='grid grid-cols-[200px,1fr] items-center'
        name='tg_dd'
        type='checkbox'
        disabled={formMode === 'view'}
      />
    </div>
  );
};
